import {
  refreshArtifactData,
  useProjectArtifactAutoOpen as useProjectArtifactAutoOpenCore,
  type ProjectArtifactAutoOpenPorts,
} from '@heidi/agents/data';

import { getWorkHostPort } from '../../work-home/work-home-ports';
import { artifactFromToolUse } from '../harness/artifactFromTool';
import {
  invalidateCachesForAgentToolWrite,
  isAgentToolWriteRequiringCacheRefresh,
  resolveAgentToolCacheContext,
} from './agentToolCacheInvalidation';

// The binding half of the auto-open: the bound artifact deriver, and the cache
// reactions, which reach other domains' caches. Module scope, so each port keeps
// one identity. getWorkHostPort is only called inside the refresh callback.
const PORTS: ProjectArtifactAutoOpenPorts = {
  artifactFromToolUse,
  refreshArtifactData: (artifact, queryClient) =>
    refreshArtifactData(artifact, queryClient, (sessionId) =>
      getWorkHostPort('integrations').lettersQueryOptions(sessionId)
    ),
  isAgentToolWriteRequiringCacheRefresh,
  onAgentToolWrite: (item, queryClient, onSessionsChanged) => {
    const { sessionId, patientProfileId, documentId, workflowId, templateId } =
      resolveAgentToolCacheContext(item);
    invalidateCachesForAgentToolWrite({
      queryClient,
      toolName: item.name,
      sessionId,
      patientProfileId,
      documentId,
      workflowId,
      templateId,
      onSessionsChanged,
    });
  },
};

export const useProjectArtifactAutoOpen = (
  args: Parameters<typeof useProjectArtifactAutoOpenCore>[0]
) => useProjectArtifactAutoOpenCore(args, PORTS);
